import { render, staticRenderFns } from "./Entregas.vue?vue&type=template&id=b070c11c"
import script from "./Entregas.vue?vue&type=script&lang=js"
export * from "./Entregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports